import { Component, OnInit } from '@angular/core';
import { TranslationService, WindowRef, I18nModule } from '@spartacus/core';
import { ToastrService } from 'ngx-toastr';
import { pairwise } from 'rxjs/operators';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { CustomProductsService } from '../custom-products/custom-products.service';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { AddressBookModel } from 'src/app/core/model/address-book-model';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgIf, TitleCasePipe } from '@angular/common';
@Component({
    selector: 'app-custom-addressbook',
    templateUrl: './custom-addressbook.component.html',
    styleUrls: ['./custom-addressbook.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, NgIf, TitleCasePipe, I18nModule]
})
export class CustomAddressbookComponent implements OnInit {
  title: any;
  error: any;
  navigationData: any;
  noData = false;
  enableLoader = true;
  usergroup: any;
  addressBookDetails: AddressBookModel;
  constructor(private translation: TranslationService, private toastService: ToastrService,
              private customProfileService: CustomProfileService, private userAccountFacade: UserAccountFacade,
              private customProductService: CustomProductsService, private winRef: WindowRef) { }

  ngOnInit(): void {
    this.customProductService.getHomeLinkActive(false);
    this.customProductService.scrollToTop();
    this.translation.translate('breadcrumb.addressbook.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('home.toastErrorMessages.addressBook').subscribe(res => {
      this.error = res;
    });
    this.userAccountFacade.get().subscribe((res: any) => {
      if (res) {
        this.usergroup = this.winRef.localStorage.getItem('groupCompany');//res.orgUnit.uid;
        this.getAddressBookDetails();
        this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
          if (previous !== current) {
            if (current != null) {
              this.enableLoader = true;
              this.getAddressBookDetails();
            }
          }
        });
      }
    });
  }
  getAddressBookDetails(): any {
    this.customProfileService.getAddressBookData(this.usergroup).subscribe(data => {
      this.enableLoader = false;
      this.noData = false;
      if (!data || Object.keys(data).length === 0) {
        this.noData = true;
      } else {
        this.addressBookDetails = new AddressBookModel(data) ;
        this.noData = false;
      }
    }, err => {
      this.enableLoader = false;
      this.toastService.show(this.error);
    });

  }
}
